import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
// import { FaRegEyeSlash } from "react-icons/fa";
import ApiUrl from "../Environment/ApiUrl";
import { RatesContext } from "../Pages/RatesContext";
import { useToast } from "../Toast/ToastContext";

function AddSales({ toggleSidebar }) {
  const location = useLocation();
  const toast = useToast();
  const navigate = useNavigate();
  const { rates } = useContext(RatesContext) || {
    rates: { gold_1g_rate: "", silver_10g_rate: "", cold_coin_rate: "" },
  };
  const [loading, setLoading] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState("New");
  const [paymentType, setPaymentType] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [payments, setPayments] = useState([]);
  const [productData, setProductData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [generateNumber, setGenerateNumber] = useState("");
  const [generateCustomerNumber, setGenerateCustomerNumber] = useState("");
  const [items, setItems] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [dailyRatesGetting, setDailyRatesGetting] = useState([]);
  const [makingWastagePercentage, setMakingWastagePercentage] = useState("");
  const [makingWastageValue, setMakingWastageValue] = useState("");
  const [isRoundOffEnabled, setIsRoundOffEnabled] = useState(false);
  const [isRateManuallyEdited, setIsRateManuallyEdited] = useState(false);
  const [userdata, setUserdata] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isManagerLocked, setIsManagerLocked] = useState(false);
  const [isStaffLocked, setIsStaffLocked] = useState(false);
  const [adjustment, setAdjustment] = useState("");
  const [isAdjustmentApplied, setIsAdjustmentApplied] = useState(false);
  const [stoneValue, setStoneValue] = useState("");
  const [appliedAdjustment, setAppliedAdjustment] = useState("0.00");
  const [discountAmountInput, setDiscountAmountInput] = useState("0.00");
  const [isGstIncluded, setIsGstIncluded] = useState(false);
  const [refundPayType, setRefundPayType] = useState("");
  const [showMaxDiscount, setShowMaxDiscount] = useState(false);

  // Stock Data State
  const [stockData, setStockData] = useState([]);
  const [stockLoading, setStockLoading] = useState(false);

  const [showProductModal, setShowProductModal] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);
  const [productFormErrors, setProductFormErrors] = useState({});
  const [productAddData, setProductAddData] = useState({
    item_code: "",
    item_name: "",
    item_name_english: "",
    item_name_tamil: "",
    category: "",
    type: "",
    pure_percent: "",
    status: "Active",
    image: null,
  });

  const [addData, setAddData] = useState({
    sales_no: "",
    sales_date: getCurrentDate(),
    customer_type: "",
    customer_id: "",
    customer_name: "",
    mobile: "",
    address: "",
    status: "Active",
    sub_total: "0.00",
    total: "0.00",
    exchange_old_value: "0.00",
    discount: "",
    discount_value: "0.00",
    tax: "",
    tax_percentage: "0.00",
    gross_weight: "",
    paid: "0.00",
    balance: "0.00",
    notes: "",
    round_off: "0.00",
    net_total: "0.00",
    refund_amount: "0.00",
    select_category: "",
    select_type: "",
    quantity: "",
    weight: "",
    rate: "",
    making_charges: "",
    amount: "0.00",
    manager: "",
    staff: "",
    item_list: [],
    payment_history: [],
  });

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // ==================== STOCK FUNCTIONS ====================

  // Fetch stock data
  const fetchStockData = async () => {
    try {
      setStockLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/stock.php`);
      const data = Array.isArray(response.data?.data) ? response.data.data : [];
      setStockData(data);
      console.log("Stock data fetched:", data);
    } catch (error) {
      console.error("Error fetching stock data:", error.message);
      toast.error("Failed to fetch stock data", 3000, "topRight");
      setStockData([]);
    } finally {
      setStockLoading(false);
    }
  };

  // Check stock availability for a specific item — compares WEIGHT (grams)
  // against the stock's avaliable_weight, not piece quantity.
  const checkStockAvailability = (
    category,
    itemName,
    weight,
    selectedTypeId,
  ) => {
    let stockItem = null;

    if (selectedTypeId) {
      const selectedProduct = productData.find(
        (p) => String(p.id) === String(selectedTypeId),
      );

      if (selectedProduct) {
        const productName =
          selectedProduct.item_name_english || selectedProduct.item_name;
        stockItem = stockData.find(
          (item) =>
            item.category?.toLowerCase() === category?.toLowerCase() &&
            (item.item?.toLowerCase() === productName?.toLowerCase() ||
              item.item_name_english?.toLowerCase() ===
                productName?.toLowerCase()),
        );

        if (!stockItem) {
          stockItem = stockData.find(
            (item) =>
              item.category?.toLowerCase() === category?.toLowerCase() &&
              (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
                item.item_name_english
                  ?.toLowerCase()
                  .includes(productName?.toLowerCase())),
          );
        }
      }
    }

    if (!stockItem && itemName) {
      stockItem = stockData.find(
        (item) =>
          item.category?.toLowerCase() === category?.toLowerCase() &&
          (item.item?.toLowerCase() === itemName?.toLowerCase() ||
            item.item_name_english?.toLowerCase() === itemName?.toLowerCase()),
      );
    }

    if (!stockItem && selectedAction === "Exchange") {
      stockItem = stockData.find(
        (item) => item.category?.toLowerCase() === category?.toLowerCase(),
      );
    }

    if (!stockItem) {
      console.warn("Item not found in stock:", {
        category,
        itemName,
        selectedTypeId,
      });

      // A product must exist in the general stock before it can be sold,
      // regardless of action type (New, Po-Sale, etc.).
      return {
        available: false,
        message:
          "This product is not present in general stock. Please add it to stock before selling.",
        availableWeight: 0,
        itemFound: false,
      };
    }

    // avaliable_weight comes back as a string like "123.456g" — strip the
    // trailing "g" before parsing. Fall back to the item's total weight
    // field if avaliable_weight isn't present for some reason.
    const availableWeight =
      parseFloat(
        String(stockItem.avaliable_weight ?? stockItem.weight ?? "0").replace(
          /g$/i,
          "",
        ),
      ) || 0;
    const requestedWeight = parseFloat(weight) || 0;

    console.log(
      `Stock check: ${itemName} - Available: ${availableWeight}g, Requested: ${requestedWeight}g`,
    );

    if (requestedWeight > availableWeight) {
      return {
        available: false,
        message: `Only ${availableWeight.toFixed(3)}g available. Requested: ${requestedWeight.toFixed(3)}g`,
        availableWeight,
        itemFound: true,
        stockItem: stockItem,
      };
    }

    return {
      available: true,
      message: "Stock available",
      availableWeight,
      itemFound: true,
      stockItem: stockItem,
    };
  };

  // Get stock status for display — based on WEIGHT (grams) available.
  const getStockStatus = (category, itemName, selectedTypeId) => {
    let stockItem = null;

    if (selectedTypeId) {
      const selectedProduct = productData.find(
        (p) => String(p.id) === String(selectedTypeId),
      );

      if (selectedProduct) {
        const productName =
          selectedProduct.item_name_english || selectedProduct.item_name;
        stockItem = stockData.find(
          (item) =>
            item.category?.toLowerCase() === category?.toLowerCase() &&
            (item.item?.toLowerCase() === productName?.toLowerCase() ||
              item.item_name_english?.toLowerCase() ===
                productName?.toLowerCase()),
        );

        if (!stockItem) {
          stockItem = stockData.find(
            (item) =>
              item.category?.toLowerCase() === category?.toLowerCase() &&
              (item.item?.toLowerCase().includes(productName?.toLowerCase()) ||
                item.item_name_english
                  ?.toLowerCase()
                  .includes(productName?.toLowerCase())),
          );
        }
      }
    }

    if (!stockItem && itemName) {
      stockItem = stockData.find(
        (item) =>
          item.category?.toLowerCase() === category?.toLowerCase() &&
          (item.item?.toLowerCase() === itemName?.toLowerCase() ||
            item.item_name_english?.toLowerCase() === itemName?.toLowerCase()),
      );
    }

    if (!stockItem) {
      return { status: "unknown", available: 0, itemFound: false };
    }

    const available =
      parseFloat(
        String(stockItem.avaliable_weight ?? stockItem.weight ?? "0").replace(
          /g$/i,
          "",
        ),
      ) || 0;
    let status = "available";
    if (available === 0) status = "out-of-stock";
    else if (available < 5) status = "low-stock"; // low-stock threshold in grams

    return { status, available, itemFound: true };
  };

  // ==================== END STOCK FUNCTIONS ====================

  const fetchLoggedInUser = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      console.log("Logged in user:", userInfo);
      if (userInfo && userInfo.user_id) {
        setLoggedInUser(userInfo);
      }
    } catch (error) {
      console.error("Error fetching logged-in user:", error);
    }
  };

  function formatDateToDDMMYYYY(dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  const translateToTamil = async (englishText) => {
    if (!englishText || englishText.trim().length < 2) return "";
    setIsTranslating(true);
    const apis = [
      async () => {
        const encoded = encodeURIComponent(englishText.trim());
        const res = await fetch(
          `https://api.mymemory.translated.net/get?q=${encoded}&langpair=en|ta`,
        );
        const data = await res.json();
        const translated = data?.responseData?.translatedText;
        if (
          translated &&
          translated.toLowerCase() !== englishText.toLowerCase()
        ) {
          return translated;
        }
        return null;
      },
      async () => {
        const encoded = encodeURIComponent(englishText.trim());
        const res = await fetch(`https://lingva.ml/api/v1/en/ta/${encoded}`);
        if (res.ok) {
          const data = await res.json();
          if (data.translation && data.translation !== englishText) {
            return data.translation;
          }
        }
        return null;
      },
      async () => {
        const res = await fetch("https://libretranslate.com/translate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            q: englishText.trim(),
            source: "en",
            target: "ta",
            format: "text",
          }),
        });
        if (res.ok) {
          const data = await res.json();
          if (data.translatedText) {
            return data.translatedText;
          }
        }
        return null;
      },
    ];
    for (const api of apis) {
      try {
        const result = await api();
        if (result) {
          setIsTranslating(false);
          return result;
        }
      } catch (error) {
        console.warn("Translation API failed:", error);
        continue;
      }
    }
    setIsTranslating(false);
    return "";
  };

  const fetchProductItemCode = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/product.php/generate-item-code`,
      );
      setProductAddData((prev) => ({
        ...prev,
        item_code: response.data?.item_code || "",
      }));
    } catch (error) {
      console.error("Error fetching product item code:", error.message);
      toast.error("Failed to generate product code", 3000, "topRight");
    }
  };

  const openProductModal = () => {
    fetchProductItemCode();
    setProductAddData({
      item_code: "",
      item_name: "",
      item_name_english: "",
      item_name_tamil: "",
      category: "",
      type: "",
      pure_percent: "",
      status: "Active",
      image: null,
    });
    setProductFormErrors({});
    setShowProductModal(true);
  };

  const closeProductModal = () => {
    setShowProductModal(false);
    setProductAddData({
      item_code: "",
      item_name: "",
      item_name_english: "",
      item_name_tamil: "",
      category: "",
      type: "",
      pure_percent: "",
      status: "Active",
      image: null,
    });
    setProductFormErrors({});
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!productAddData.item_name_english)
      errors.item_name = "Item name is required";
    if (!productAddData.category) errors.category = "Category is required";
    if (!productAddData.pure_percent)
      errors.pure_percent = "Purity percentage is required";
    if (!productAddData.status) errors.status = "Status is required";
    if (Object.keys(errors).length > 0) {
      setProductFormErrors(errors);
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      let finalTamilName = productAddData.item_name_tamil;
      if (!finalTamilName && productAddData.item_name_english) {
        finalTamilName = await translateToTamil(
          productAddData.item_name_english,
        );
      }
      formData.append("item_code", productAddData.item_code || "");
      formData.append("item_name", productAddData.item_name_english || "");
      formData.append(
        "item_name_english",
        productAddData.item_name_english || "",
      );
      formData.append("item_name_tamil", finalTamilName || "");
      formData.append("category", productAddData.category || "");
      formData.append("type", productAddData.type || "");
      formData.append("pure_percent", productAddData.pure_percent || "");
      formData.append("status", productAddData.status || "");
      formData.append("created_by", "system");
      if (productAddData.image) {
        formData.append("image", productAddData.image);
      }
      const response = await axios.post(`${ApiUrl}/Api/product.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (
        response.data?.status === true ||
        response.status === 200 ||
        response.status === 201
      ) {
        toast.success("Product added successfully!", 3000, "topRight");
        closeProductModal();
        await fetchProductData();
        await fetchStockData(); // Refresh stock data after adding product
      } else {
        throw new Error(response.data?.message || "Failed to add product");
      }
    } catch (error) {
      console.error("Error adding product:", error);
      toast.error(
        error.response?.data?.message || "Failed to add product",
        3000,
        "topRight",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    toggleSidebar();
    fetchProductData();
    fetchCustomerData();
    fetchDataGenerate();
    fetchDailyRatesData();
    fetchuserdata();
    fetchLoggedInUser();
    fetchStockData(); // Fetch stock data on component mount

    if (location.state?.restore) {
      const {
        addData: savedData,
        items: savedItems,
        payments: savedPayments,
        selectedAction: savedAction,
        makingWastagePercentage: savedMWP,
        makingWastageValue: savedMWV,
      } = location.state.restore;
      if (savedData) setAddData((prev) => ({ ...prev, ...savedData }));
      if (savedItems) setItems(savedItems);
      if (savedPayments) setPayments(savedPayments);
      if (savedAction) setSelectedAction(savedAction);
      if (savedMWP) setMakingWastagePercentage(savedMWP);
      if (savedMWV) setMakingWastageValue(savedMWV);
    }
  }, []);

  // Refresh stock data periodically
  useEffect(() => {
    const interval = setInterval(() => {
      fetchStockData();
    }, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  const fetchuserdata = async () => {
    try {
      const fetchuser = await axios.get(`${ApiUrl}/Api/user.php`);
      const userDataArray = Array.isArray(fetchuser.data.data)
        ? fetchuser.data.data
        : [];
      setUserdata(userDataArray);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setUserdata([]);
      toast.error("Failed to fetch user data", 3000, "topRight");
    }
  };

  useEffect(() => {
    console.log("loggedInUser:", loggedInUser);
    console.log("userdata:", userdata);
    if (loggedInUser && userdata.length > 0) {
      const currentUser = userdata.find(
        (u) => u.user_id === loggedInUser.user_id,
      );
      console.log("currentUser found:", currentUser);
      if (!currentUser) {
        console.log("User not found in userdata");
        return;
      }
      console.log("Current user role:", currentUser.role);
      if (currentUser.role === "Manager" || currentUser.role === "manager") {
        console.log("Setting as Manager");
        setSelectedManager(currentUser.id.toString());
        setIsManagerLocked(true);
        setAddData((prev) => ({
          ...prev,
          manager: currentUser.name,
          manager_name: currentUser.name,
        }));
        const allStaff = userdata.filter(
          (user) => user.role === "Employee" || user.role === "employee",
        );
        setStaffList(allStaff);
      } else if (
        currentUser.role === "Employee" ||
        currentUser.role === "employee"
      ) {
        console.log("Setting as Employee");
        setSelectedStaff(currentUser.name);
        setIsStaffLocked(true);
        setAddData((prev) => ({
          ...prev,
          staff: currentUser.name,
        }));
        const allStaff = userdata.filter(
          (user) => user.role === "Employee" || user.role === "employee",
        );
        setStaffList(allStaff);
      } else {
        console.log("User is Admin - manager dropdown only, no staff dropdown");
      }
    }
  }, [loggedInUser, userdata]);

  const handleManagerChange = (e) => {
    if (isManagerLocked) return;
    const managerId = e.target.value;
    setSelectedManager(managerId);
    if (managerId) {
      const selectedManagerObj = userdata.find(
        (user) => user.id === parseInt(managerId),
      );
      const managerName = selectedManagerObj ? selectedManagerObj.name : "";
      const allStaff = userdata.filter(
        (user) => user.role === "Employee" || user.role === "employee",
      );
      setStaffList(allStaff);
      setAddData((prev) => ({
        ...prev,
        manager: managerName,
        manager_name: managerName,
      }));
    } else {
      setStaffList([]);
      setAddData((prev) => ({
        ...prev,
        manager: "",
        manager_name: "",
      }));
    }
  };

  const handleStaffChange = (e) => {
    if (isStaffLocked) return;
    const staffId = e.target.value;
    setSelectedStaff(staffId);
    setAddData((prev) => ({
      ...prev,
      staff: staffId,
    }));
  };

  const fetchDailyRatesData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);
      setDailyRatesGetting(response.data.data || []);
    } catch (error) {
      console.error("Error fetching daily rates:", error.message);
    }
  };

  const fetchProductData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/product.php`);
      setProductData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
      setProductData([]);
    }
  };

  const fetchCustomerData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/customer.php`);
      setCustomerData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching customers:", error.message);
      setCustomerData([]);
    }
  };

  const fetchDataGenerate = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/Api/sales.php/generate-sales-code`,
      );
      setGenerateNumber(response.data?.sales_no || "");
      setAddData((prev) => ({
        ...prev,
        sales_no: response.data?.sales_no || "",
      }));
    } catch (error) {
      console.error("Error fetching sales code:", error.message);
      setGenerateNumber("");
    }
  };

  // ===================================================================
  // Reset ONLY the Exchange-specific fields when the user leaves
  // Exchange mode. This effect no longer touches `weight` / `amount`.
  // ===================================================================
  useEffect(() => {
    if (selectedAction !== "Exchange") {
      setAddData((prev) => ({
        ...prev,
        gross_weight: "",
        exchange_wastage_g: "",
      }));
    }
  }, [selectedAction]);

  // ===================================================================
  // EXCHANGE MODE — Auto calculate Net Weight & Amount.
  // ===================================================================
  useEffect(() => {
    if (selectedAction !== "Exchange") return;
    // Don't stomp on a manual +/- adjustment already applied to the amount.
    if (isAdjustmentApplied) return;

    const gross = parseFloat(addData.gross_weight) || 0;
    const wastage = parseFloat(addData.exchange_wastage_g) || 0;
    const rate = parseFloat(addData.rate) || 0;
    if (gross > 0 && wastage >= 0 && gross >= wastage) {
      const netWeight = (gross - wastage).toFixed(3);
      const amount = (netWeight * rate).toFixed(2);
      setAddData((prev) => ({
        ...prev,
        weight: netWeight,
        amount: amount,
      }));
    } else {
      setAddData((prev) => ({
        ...prev,
        weight: gross > 0 && wastage > gross ? "" : prev.weight,
        amount: "0.00",
      }));
    }
  }, [
    selectedAction,
    addData.gross_weight,
    addData.exchange_wastage_g,
    addData.rate,
    isAdjustmentApplied,
  ]);

  const openCustomerModal = () => setShowCustomerModal(true);
  const closeCustomerModal = () => setShowCustomerModal(false);

  const handleAddCustomerClick = () => {
    setAddData({
      ...addData,
      customer_type: "",
      customer_id: "",
      customer_name: "",
      mobile: "",
      address: "",
      status: "Active",
    });
    setGenerateCustomerNumber("");
    openCustomerModal();
  };

  const generateCustomerId = async (customerType) => {
    if (!customerType) return;
    try {
      if (customerType === "Walk-In") {
        setGenerateCustomerNumber(`TJWI-${Date.now().toString().slice(-3)}`);
      } else {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-customer-code`,
        );
        setGenerateCustomerNumber(response.data?.customer_id || "");
      }
    } catch (error) {
      console.error("Error generating customer ID:", error.message);
      toast.error("Failed to generate customer ID", 3000, "topRight");
      setGenerateCustomerNumber("");
    }
  };

  const fetchWalkInDummyCustomer = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/customer.php`);
      const customers = response.data?.data || [];
      const walkInCustomer = customers.find(
        (c) => c.customer_type === "Walk-In",
      );
      if (walkInCustomer) {
        setAddData((prev) => ({
          ...prev,
          customer_id: walkInCustomer.customer_id,
          customer_name: walkInCustomer.name || "Walk-In Customer",
          mobile: walkInCustomer.mobile || "",
        }));
      }
    } catch (error) {
      console.error("Error fetching walk-in dummy customer:", error.message);
    }
  };

  const handleCustomerTypeChange = async (e) => {
    const customerType = e.target.value;
    setAddData((prev) => ({
      ...prev,
      customer_type: customerType,
      customer_id: "",
      customer_name: "",
      mobile: "",
    }));
    if (customerType === "Walk-In") {
      const walkInId = `TJWI-${Date.now().toString().slice(-3)}`;
      setGenerateCustomerNumber(walkInId);
      fetchWalkInDummyCustomer();
    } else if (customerType) {
      try {
        const response = await axios.get(
          `${ApiUrl}/Api/customer.php/generate-customer-code`,
        );
        setGenerateCustomerNumber(response.data?.customer_id || "");
      } catch (error) {
        console.error("Error generating customer ID:", error.message);
        toast.error("Failed to generate customer ID", 3000, "topRight");
      }
    } else {
      setGenerateCustomerNumber("");
    }
  };

  const handleCustomerChange = (e) => {
    const selectedCustomerId = e.target.value;
    const selectedCustomer = customerData.find(
      (customer) => customer.customer_id === selectedCustomerId,
    );
    if (selectedCustomer) {
      setAddData({
        ...addData,
        customer_id: selectedCustomer.customer_id,
        customer_name: selectedCustomer.name || "",
        mobile: selectedCustomer.mobile || "",
        customer_type: selectedCustomer.customer_type || "",
      });
    } else {
      setAddData({
        ...addData,
        customer_id: "",
        customer_name: "",
        mobile: "",
      });
    }
  };

  const handleCustomerSubmit = async (e) => {
    e.preventDefault();
    if (addData.customer_type !== "Walk-In" && !generateCustomerNumber) {
      toast.error("Please wait for customer ID to generate", 3000, "topRight");
      return;
    }
    if (
      !addData.customer_type ||
      !addData.customer_name ||
      !addData.mobile ||
      !addData.status
    ) {
      toast.error("Please fill all required fields", 3000, "topRight");
      return;
    }
    setLoading(true);
    try {
      let finalCustomerId = generateCustomerNumber;
      if (addData.customer_type === "Walk-In") {
        finalCustomerId = `TJWI-${Date.now().toString().slice(-3)}`;
      }
      const customerPayload = {
        customer_type: addData.customer_type,
        customer_id: finalCustomerId,
        name: addData.customer_name,
        mobile: addData.mobile,
        address: addData.address || "",
        aadhar_number: addData.aadhar_number || "",
        status: addData.status,
        created_by: "Addsales",
        created_date: new Date().toISOString(),
      };
      console.log("Sending customer payload:", customerPayload);
      const response = await axios.post(
        `${ApiUrl}/Api/customer.php`,
        customerPayload,
      );
      console.log("Customer API response:", response.data);
      if (response.status === 200 || response.status === 201) {
        const savedCustomerId = response.data?.customer_id || finalCustomerId;
        toast.success("Customer added successfully!", 3000, "topRight");
        await fetchCustomerData();
        setAddData((prev) => ({
          ...prev,
          customer_id: savedCustomerId,
          customer_name: addData.customer_name,
          mobile: addData.mobile,
          customer_type: addData.customer_type,
        }));
        closeCustomerModal();
        toast.success(`Customer ID: ${savedCustomerId}`, 2000, "topRight");
      } else {
        throw new Error(response.data.message || "Failed to add customer");
      }
    } catch (error) {
      console.error("Error adding customer:", error);
      toast.error(
        `Failed to add customer: ${error.response?.data?.message || error.message}`,
        3000,
        "topRight",
      );
    } finally {
      setLoading(false);
    }
  };

  // ===================================================================
  // Auto-calculates `amount` whenever quantity / weight / rate / making
  // charges / wastage / stone value change. Gated by isAdjustmentApplied
  // so a manual +/- adjustment isn't overwritten.
  // ===================================================================
  useEffect(() => {
    if (!addData.quantity || !addData.weight || !addData.rate) {
      setAddData((prev) => ({ ...prev, amount: "0.00" }));
      return;
    }
    if (isAdjustmentApplied) return;

    // NOTE: addData.rate already has the selected product's Pure %
    // baked in (see the Rate auto-fill effect above), so amount is
    // now just quantity x weight x rate — no separate purity multiply.
    let baseAmount =
      parseFloat(addData.quantity) *
      parseFloat(addData.weight) *
      parseFloat(addData.rate);

    if (selectedAction === "New" && addData.making_charges) {
      baseAmount += parseFloat(addData.making_charges);
    }
    if (makingWastageValue) {
      const wastage = parseFloat(makingWastageValue);
      if (selectedAction === "Exchange") {
        baseAmount -= wastage;
      } else {
        baseAmount += wastage;
      }
    }
    if (
      (selectedAction === "New" || selectedAction === "Po-Sale") &&
      stoneValue
    ) {
      baseAmount += parseFloat(stoneValue);
    }

    setAddData((prev) => ({ ...prev, amount: baseAmount.toFixed(2) }));
  }, [
    addData.quantity,
    addData.weight,
    addData.rate,
    addData.making_charges,
    makingWastageValue,
    selectedAction,
    isAdjustmentApplied,
    stoneValue,
    addData.select_type,
    productData,
  ]);

  // Adjustment is entered as a WEIGHT (g). The ₹ impact of the adjustment
  // (weight × rate) is what moves the amount — the item's actual weight
  // (Total Weight (g) in Exchange mode) itself is never touched. "−"
  // reduces (less) the amount by weight × rate; "+" adds it back (e.g. to
  // undo/correct). We keep the WEIGHT (not the ₹ value) in `adjustment` /
  // item.adjustment so the UI can display "Adj: -0.500 g" etc.
  const applyAdjustment = (sign) => {
    const adjustmentWeight = parseFloat(adjustment) || 0;
    if (adjustmentWeight === 0) return;
    const rate = parseFloat(addData.rate) || 0;
    const signedWeight = sign === "+" ? adjustmentWeight : -adjustmentWeight;
    const adjustmentAmount = signedWeight * rate;
    const currentAmount = parseFloat(addData.amount) || 0;
    const newAmount = currentAmount + adjustmentAmount;
    setAddData((prev) => ({ ...prev, amount: newAmount.toFixed(2) }));
    setIsAdjustmentApplied(true);
    setAdjustment(signedWeight.toFixed(3));
  };

  useEffect(() => {
    const subtotal = items
      .filter((item) => item.action_type !== "Exchange")
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    setAddData((prev) => ({
      ...prev,
      total: subtotal.toFixed(2),
      sub_total: subtotal.toFixed(2),
    }));
  }, [items]);

  // Today's actual market/selling rate for a category — the SAME rate used
  // when the item was priced (see handleCategoryChange / rate auto-fill),
  // not the separate "pure percentage" rate fields.
  const getTodaysMarketRate = (category) => {
    const today = formatDateToDDMMYYYY(getCurrentDate());
    const todayRateRow = dailyRatesGetting.find((r) => r.date === today) || {};

    if (category === "Gold") {
      return parseFloat(todayRateRow.gold_1g_rate || rates.gold_1g_rate || 0);
    }
    if (category === "Silver") {
      return parseFloat(
        todayRateRow.silver_10g_rate || rates.silver_10g_rate || 0,
      );
    }
    if (category === "Gold Coin") {
      return parseFloat(
        todayRateRow.cold_coin_rate || rates.cold_coin_rate || 0,
      );
    }
    if (category === "Silver Coin") {
      return parseFloat(
        todayRateRow.silver_coin_rate || rates.silver_coin_rate || 0,
      );
    }
    return 0;
  };

  // The minimum a sale's subtotal is allowed to be discounted down to:
  // the sum, across every non-exchange item (INCLUDING Gold Coin / Silver
  // Coin), of qty x weight x that item's own Pure % (from the Product
  // page) x today's market rate for its category.
  const getSalePureFloor = () =>
    items
      .filter((item) => item.action_type !== "Exchange")
      .reduce((sum, item) => {
        const product = productData.find(
          (p) => String(p.id) === String(item.type_id),
        );
        const purity = product?.pure_percent
          ? parseFloat(product.pure_percent) / 100
          : 1;
        const qty = parseFloat(item.quantity || 0);
        const weight = parseFloat(item.weight || 0);
        const todaysRate = getTodaysMarketRate(item.category);
        return sum + qty * weight * purity * todaysRate;
      }, 0);

  // The highest discount % that still leaves the subtotal at/above the
  // pure-metal floor above — e.g. today's gold rate ₹10,000, an item's
  // Pure % is 90%, so its floor is ₹9,000; if that's the whole sale
  // total, the max discount is 10%.
  const getMaxDiscountPercent = () => {
    const total = parseFloat(addData.total) || 0;
    if (total <= 0) return 0;
    const pureFloor = getSalePureFloor();
    if (pureFloor <= 0) return 100;
    const maxPct = ((total - pureFloor) / total) * 100;
    return maxPct > 0 ? maxPct : 0;
  };

  useEffect(() => {
    const total = parseFloat(addData.total) || 0;
    const discountPercentage = parseFloat(addData.discount) || 0;
    const taxPercentage = parseFloat(addData.tax) || 0;
    const exchangeOldValue = items
      .filter((item) => item.action_type === "Exchange")
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    let discountAmount = (total * discountPercentage) / 100;
    let subtotal = total - discountAmount;

    // Discount floor: never let the discounted subtotal drop below the
    // pure-metal value of the items (that value comes from each
    // product's Pure % on the Product page, not a flat 90% assumption).
    const pureFloor = getSalePureFloor();
    if (discountPercentage > 0 && pureFloor > 0 && subtotal < pureFloor) {
      subtotal = pureFloor;
      discountAmount = total - subtotal;
      if (discountAmount < 0) discountAmount = 0;
    }

    const taxAmount = (subtotal * taxPercentage) / 100;
    let netTotal = subtotal + taxAmount;
    let roundOffValue = 0;
    if (isRoundOffEnabled) {
      const decimalPart = netTotal - Math.floor(netTotal);
      if (decimalPart < 0.5) {
        roundOffValue = -decimalPart;
        netTotal = Math.floor(netTotal);
      } else {
        roundOffValue = 1 - decimalPart;
        netTotal = Math.ceil(netTotal);
      }
    }
    let balance = netTotal - exchangeOldValue - parseFloat(addData.paid || 0);
    if (total === 0) {
      balance = parseFloat(addData.paid || 0) - exchangeOldValue;
    }

    // If the exchanged (old) value is worth more than the sale itself,
    // the shop owes the customer the difference — capture that as a
    // separate "Paid to Customer" amount rather than folding it into
    // Balance, so the bill can call it out explicitly with a pay type.
    const refundAmount =
      exchangeOldValue > netTotal ? exchangeOldValue - netTotal : 0;

    setAddData((prev) => ({
      ...prev,
      discount_value: discountAmount.toFixed(2),
      sub_total: subtotal.toFixed(2),
      tax_percentage: taxAmount.toFixed(2),
      exchange_old_value: exchangeOldValue.toFixed(2),
      net_total: netTotal.toFixed(2),
      round_off: roundOffValue.toFixed(2),
      balance: balance.toFixed(2),
      refund_amount: refundAmount.toFixed(2),
    }));
  }, [
    addData.total,
    addData.discount,
    addData.tax,
    isRoundOffEnabled,
    addData.paid,
    items,
    productData,
    dailyRatesGetting,
  ]);

  useEffect(() => {
    if (parseFloat(addData.refund_amount || 0) <= 0 && refundPayType) {
      setRefundPayType("");
    }
  }, [addData.refund_amount]);

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    let rate = "";
    setIsRateManuallyEdited(false);
    const today = formatDateToDDMMYYYY(getCurrentDate());
    const todayRate =
      dailyRatesGetting.find((rate) => rate.date === today) || {};
    if (selectedCategory === "Gold") {
      if (selectedAction === "Old Sales") {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      } else if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
      }
    } else if (selectedCategory === "Silver") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = (
          parseFloat(todayRate.silver_10g_rate) ||
          parseFloat(rates.silver_10g_rate) ||
          ""
        ).toString();
      }
    } else if (selectedCategory === "Gold Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      }
    } else if (selectedCategory === "Silver Coin") {
      if (selectedAction === "Exchange") {
        rate = "";
      } else {
        rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
      }
    }
    setAddData((prev) => ({
      ...prev,
      select_category: selectedCategory,
      select_type: "",
      rate,
    }));
  };

  // ===================================================================
  // Rate auto-fill bails out entirely while an item is being edited.
  // ===================================================================
  useEffect(() => {
    if (editingIndex !== null) return;

    if (
      isRateManuallyEdited &&
      (selectedAction === "Exchange" || selectedAction === "Old Sales")
    ) {
      return;
    }
    let rate = "";
    const today = formatDateToDDMMYYYY(getCurrentDate());
    const todayRate = dailyRatesGetting.find((r) => r.date === today) || {};
    if (addData.select_category === "Gold") {
      if (selectedAction === "Old Sales") {
        rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
      } else {
        rate = todayRate.gold_1g_rate || rates.gold_1g_rate || "";
      }
    } else if (addData.select_category === "Silver") {
      rate = todayRate.silver_10g_rate || rates.silver_10g_rate || "";
    } else if (addData.select_category === "Gold Coin") {
      rate = todayRate.cold_coin_rate || rates.cold_coin_rate || "";
    } else if (addData.select_category === "Silver Coin") {
      rate = todayRate.silver_coin_rate || rates.silver_coin_rate || "";
    }

    // Apply the selected product's purity (Pure %) to today's market
    // rate, so the Rate field shown/stored on the item is the actual
    // sale rate for that specific product, not just the raw market rate.
    if (rate && addData.select_type && selectedAction !== "Exchange") {
      const selectedProduct = productData.find(
        (p) => String(p.id) === String(addData.select_type),
      );
      if (selectedProduct?.pure_percent) {
        const purity = parseFloat(selectedProduct.pure_percent) / 100;
        rate = parseFloat(rate).toFixed(2);
      }
    }

    setAddData((prev) => ({
      ...prev,
      rate,
    }));
  }, [
    selectedAction,
    addData.select_category,
    addData.select_type,
    dailyRatesGetting,
    rates,
    isRateManuallyEdited,
    editingIndex,
    productData,
  ]);

  const handleMakingWastagePercentageChange = (e) => {
    const percentage = e.target.value;
    if (/^\d*\.?\d{0,2}$/.test(percentage)) {
      setMakingWastagePercentage(percentage);
      setMakingWastageValue("");
      if (addData.weight && addData.rate && percentage) {
        const baseAmount =
          parseFloat(addData.weight) * parseFloat(addData.rate);
        const wastageValue = (baseAmount * parseFloat(percentage)) / 100;
        setMakingWastageValue(wastageValue.toFixed(2));
      }
    }
  };

  const handleMakingWastageValueChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setMakingWastageValue(value);
      setMakingWastagePercentage("");
      if (addData.weight && addData.rate && value) {
        const baseAmount =
          parseFloat(addData.weight) * parseFloat(addData.rate);
        const percentage = (parseFloat(value) / baseAmount) * 100;
        setMakingWastagePercentage(percentage.toFixed(2));
      }
    }
  };

  // ==================== handleAddItem (Add / Update item) ====================
  const handleAddItem = () => {
    const currentRole =
      JSON.parse(localStorage.getItem("user") || "{}").role || "";
    const isAdminRole = currentRole === "Admin" || currentRole === "admin";
    const isManagerRole =
      currentRole === "Manager" || currentRole === "manager";
    const staffRequired = !isAdminRole && !isManagerRole && !addData.staff;

    // Step 1: Required fields check
    if (
      !addData.select_category ||
      (selectedAction !== "Exchange" && !addData.select_type) ||
      !addData.quantity ||
      !addData.weight ||
      !addData.rate ||
      !addData.amount ||
      !addData.manager ||
      staffRequired
    ) {
      toast.error(
        "Please fill all required fields, including Manager" +
          (!isAdminRole ? " and Staff" : ""),
        3000,
        "topRight",
      );
      return;
    }

    // Step 2: STOCK AVAILABILITY CHECK (by WEIGHT, not piece quantity)
    // Skipped for Exchange and Old Sales (stock tracking doesn't apply there)
    if (selectedAction !== "Exchange" && selectedAction !== "Old Sales") {
      const selectedProduct = productData.find(
        (p) => String(p.id) === String(addData.select_type),
      );

      const itemName =
        selectedProduct?.item_name_english || selectedProduct?.item_name || "";
      const category = addData.select_category;
      const weight = parseFloat(addData.weight) || 0;

      const stockCheck = checkStockAvailability(
        category,
        itemName,
        weight,
        addData.select_type,
      );

      if (!stockCheck.available) {
        toast.error(
          `❌ Stock Limit Exceeded! ${stockCheck.message}`,
          5000,
          "topRight",
        );
        return; // ⛔ Stop here - item will NOT be added
      }

      if (
        stockCheck.availableWeight > 0 &&
        weight > stockCheck.availableWeight * 0.8
      ) {
        toast.warning(
          `⚠️ Low stock warning! Only ${stockCheck.availableWeight.toFixed(3)}g available. You're adding ${weight.toFixed(3)}g.`,
          5000,
          "topRight",
        );
      }

      if (stockCheck.itemFound) {
        toast.success(
          `✅ Stock available: ${stockCheck.availableWeight.toFixed(3)}g`,
          2000,
          "topRight",
        );
      }
    }

    // Step 3: Purity-based price check (Gold/Silver jewellery only —
    // coins are exempt, since their pricing isn't tied to product Pure %)
    if (
      selectedAction !== "Exchange" &&
      selectedAction !== "Old Sales" &&
      addData.select_type &&
      addData.select_category !== "Gold Coin" &&
      addData.select_category !== "Silver Coin"
    ) {
      const selectedProductForCheck = productData.find(
        (p) => String(p.id) === String(addData.select_type),
      );
      const purity = selectedProductForCheck?.pure_percent
        ? parseFloat(selectedProductForCheck.pure_percent) / 100
        : 1;

      const qty = parseFloat(addData.quantity || 0);
      const weight = parseFloat(addData.weight || 0);

      const today = formatDateToDDMMYYYY(getCurrentDate());
      const todayRateRow =
        dailyRatesGetting.find((r) => r.date === today) || {};

      let todaysPureRate = 0;
      if (addData.select_category === "Gold") {
        todaysPureRate = parseFloat(
          todayRateRow.gold_pure_percentage || rates.gold_pure_percentage || 0,
        );
      } else if (addData.select_category === "Silver") {
        todaysPureRate = parseFloat(
          todayRateRow.silver_pure_percentage ||
            rates.silver_pure_percentage ||
            0,
        );
      }

      const finalAmount = parseFloat(addData.amount || 0);
      const pureRateTotal = qty * weight * purity * todaysPureRate;

      if (todaysPureRate > 0 && finalAmount < pureRateTotal) {
        const diff = (pureRateTotal - finalAmount).toFixed(2);
        toast.error(
          `⚠️ Amount ₹${finalAmount.toFixed(2)} is below Today's Pure Rate value ₹${pureRateTotal.toFixed(2)} (Diff: ₹${diff})`,
          4000,
          "topRight",
        );
        return; // ⛔ block — item not added
      }
    }

    // Step 4: Build item object (ONLY REACHED IF ALL CHECKS PASS)
    const selectedProductObj = productData.find(
      (p) => String(p.id) === String(addData.select_type),
    );
    const typeName = selectedProductObj
      ? selectedProductObj.item_name_english || selectedProductObj.item_name
      : selectedAction === "Exchange"
        ? `Old ${addData.select_category}`
        : "";

    const newItem = {
      ...addData,
      category: addData.select_category,
      item: typeName,
      type_id: addData.select_type || "",
      making_wastage: makingWastageValue,
      making_wastage_percentage: makingWastagePercentage,
      adjustment: adjustment || "0.00",
      action_type: selectedAction,
      stone_value: stoneValue || "0.00",
    };

    console.log("➕ Adding item:", newItem);

    // Step 5: Add or update item
    if (editingIndex !== null) {
      const updated = [...items];
      updated[editingIndex] = newItem;
      setItems(updated);
      setEditingIndex(null);
      console.log("✏️ Updated items array:", updated);
    } else {
      const newItems = [...items, newItem];
      setItems(newItems);
      console.log("✅ New items array:", newItems);
    }

    // Step 6: Reset form fields
    setAddData((prev) => ({
      ...prev,
      select_category: "",
      select_type: "",
      quantity: "",
      weight: "",
      rate: "",
      making_charges: "",
      amount: "0.00",
      gross_weight: "",
    }));
    setMakingWastagePercentage("");
    setMakingWastageValue("");
    setAdjustment("");
    setAppliedAdjustment("0.00");
    setStoneValue("");
    setIsRateManuallyEdited(false);
    setIsAdjustmentApplied(false);

    if (!isManagerLocked) {
      setSelectedManager("");
      setStaffList([]);
    }
    if (!isStaffLocked) setSelectedStaff("");
  };
  // ==================== END handleAddItem ====================

  const renderAdjustmentInput = () => (
    <div className="col-md-2">
      <label className="form-label">Adjustment Wgt (g)</label>
      <div className="input-group">
        <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          style={{ height: "34px" }}
          onClick={() => applyAdjustment("-")}
          title="Reduce amount by weight × rate"
        >
          –
        </button>
        <input
          type="text"
          className="form-control"
          placeholder="0.000"
          value={adjustment}
          onChange={(e) => {
            if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === "")
              setAdjustment(e.target.value);
          }}
        />
        <button
          type="button"
          className="btn btn-outline-success btn-sm"
          style={{ height: "34px" }}
          onClick={() => applyAdjustment("+")}
          title="Add back weight × rate"
        >
          +
        </button>
      </div>
    </div>
  );

  // ===================================================================
  // handleEditItem no longer sets isAdjustmentApplied(true) so amount
  // keeps recalculating live while you edit an item.
  // ===================================================================
  const handleEditItem = (index) => {
    const item = items[index];
    if (!item) return;

    setSelectedAction(item.action_type);

    // Restore the Manager dropdown — item.manager is stored as a NAME
    // (see handleManagerChange), but the <select> is driven by the id.
    const managerObj = userdata.find(
      (u) => u.name === item.manager || u.user_id === item.manager,
    );
    const managerId = managerObj ? managerObj.id.toString() : "";

    if (!isManagerLocked) {
      setSelectedManager(managerId);
      const allStaff = userdata.filter(
        (user) => user.role === "Employee" || user.role === "employee",
      );
      setStaffList(allStaff);
    }
    if (!isStaffLocked) {
      setSelectedStaff(item.staff || "");
    }

    setAddData((prev) => ({
      ...prev,
      select_category: item.category,
      select_type: item.type_id,

      quantity: item.quantity,
      weight: item.weight,
      rate: item.rate,

      making_charges: item.making_charges || "",
      amount: item.amount,

      manager: item.manager,
      staff: item.staff,

      gross_weight: item.gross_weight || "",
    }));

    setMakingWastagePercentage(item.making_wastage_percentage || "");
    setMakingWastageValue(item.making_wastage || "");
    setStoneValue(item.stone_value || "");
    setAdjustment(item.adjustment || "");
    setEditingIndex(index);

    setIsRateManuallyEdited(true);
    setIsAdjustmentApplied(false); // ✅ allow live recalculation while editing
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleAddPayment = () => {
    if (!paymentType || !paymentAmount) {
      toast.error(
        "Please select payment type and enter amount",
        3000,
        "topRight",
      );
      return;
    }
    const newPayment = {
      sales_no: addData.sales_no,
      date: new Date().toISOString().split("T")[0],
      payment_type: paymentType,
      amount: parseFloat(paymentAmount).toFixed(2),
    };
    const updatedPayments = [...payments, newPayment];
    setPayments(updatedPayments);
    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );
    setAddData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      payment_history: updatedPayments,
    }));
    setPaymentType("");
    setPaymentAmount("");
  };

  const handleEditPayment = (index) => {
    const payment = payments[index];
    setPaymentType(payment.payment_type);
    setPaymentAmount(payment.amount);
    handleDeletePayment(index);
  };

  const handleDeletePayment = (index) => {
    const updatedPayments = payments.filter((_, i) => i !== index);
    setPayments(updatedPayments);
    const totalPaid = updatedPayments.reduce(
      (sum, payment) => sum + parseFloat(payment.amount || 0),
      0,
    );
    setAddData((prev) => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      payment_history: updatedPayments,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddData({
      ...addData,
      [name]: value,
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!addData.customer_id || !items.length) {
      toast.error(
        "Please select a customer and add at least one item",
        3000,
        "topRight",
      );
      return;
    }
    if (parseFloat(addData.refund_amount || 0) > 0 && !refundPayType) {
      toast.error(
        "Please select a pay type for the amount paid to the customer",
        3000,
        "topRight",
      );
      return;
    }
    // Hard-block save when the entered discount % exceeds the max allowed
    // (the pure-metal floor from getSalePureFloor()/getMaxDiscountPercent()).
    // The inline toast on the input only warns as the person types — this
    // is the actual gate so an over-limit discount can never be saved.
    {
      const enteredDiscount = parseFloat(addData.discount) || 0;
      const maxDiscountPct = getMaxDiscountPercent();
      if (enteredDiscount > maxDiscountPct + 0.001) {
        toast.error(
          `⚠️ Discount exceeds the maximum allowed (${maxDiscountPct.toFixed(2)}%). Please lower it before saving.`,
          4000,
          "topRight",
        );
        return;
      }
    }
    setLoading(true);
    try {
      const formData = {
        sales_no: addData.sales_no,
        sales_date: addData.sales_date,
        customer_type: addData.customer_type,
        customer_id: addData.customer_id,
        sub_total: addData.sub_total,
        total: addData.total,
        discount: addData.discount,
        discount_value: addData.discount_value,
        round_off: addData.round_off,
        tax: addData.tax,
        tax_percentage: addData.tax_percentage,
        exchange_old_value: addData.exchange_old_value,
        net_total: addData.net_total,
        paid: addData.paid || 0,
        balance: addData.balance,
        refund_amount: addData.refund_amount || "0.00",
        refund_pay_type:
          parseFloat(addData.refund_amount || 0) > 0 ? refundPayType : "",
        notes: addData.notes,
        manager: addData.manager,
        staff: addData.staff,
        item_list: items.map((item) => ({
          sales_no: item.sales_no,
          category: item.category,
          item: item.item || item.type_id,
          type_id: item.type_id,
          quantity: item.quantity,
          weight: item.weight,
          making_charges: item.making_charges || "0.00",
          making_wastage: item.making_wastage || "0.00",
          making_wastage_percentage: item.making_wastage_percentage || "0.00",
          rate: item.rate,
          amount: item.amount,
          action_type: item.action_type,
          stone_value: item.stone_value || "0.00",
          adjustment: item.adjustment || "0.00",
        })),
        payment_history: payments,
      };
      console.log("🔍 DEBUGGING ADJUSTMENT SAVE:");
      console.log("📦 Full formData:", formData);
      console.log("📋 Items array:", items);
      console.log("💰 Item list being sent:", formData.item_list);
      formData.item_list.forEach((item, index) => {
        console.log(`Item ${index + 1}:`, {
          category: item.category,
          action_type: item.action_type,
          adjustment: item.adjustment,
          stone_value: item.stone_value,
          amount: item.amount,
        });
      });
      const response = await axios.post(`${ApiUrl}/Api/sales.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("✅ Backend response:", response.data);
      if (response.status === 200) {
        toast.success("Sales saved successfully!", 3000, "topRight");
        navigate(`/bill/${addData.sales_no}`, {
          state: {
            salesData: {
              ...addData,
              refund_pay_type: formData.refund_pay_type,
              item_list: items,
              payment_history: payments,
            },
            isEstimate: false,
          },
        });
      } else {
        throw new Error(response.data.message || "Failed to save sales data");
      }
    } catch (error) {
      console.error("❌ Error saving data:", error);
      console.error("❌ Error response:", error.response?.data);
      toast.error(
        `Error saving sales data: ${error.response?.data?.message || error.message}`,
        3000,
        "topRight",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setAddData({
      sales_no: generateNumber,
      sales_date: getCurrentDate(),
      customer_type: "",
      customer_id: "",
      customer_name: "",
      mobile: "",
      address: "",
      status: "Active",
      select_category: "",
      select_type: "",
      quantity: "",
      weight: "",
      rate: "",
      making_charges: "",
      amount: "0.00",
      total: "0.00",
      sub_total: "0.00",
      exchange_old_value: "0.00",
      stoneValue: "",
      discount: "",
      discount_value: "0.00",
      tax: "",
      tax_percentage: "0.00",
      paid: "0.00",
      balance: "0.00",
      notes: "",
      round_off: "0.00",
      net_total: "0.00",
      refund_amount: "0.00",
      manager: isManagerLocked ? addData.manager : "",
      staff: isStaffLocked ? addData.staff : "",
      item_list: [],
      payment_history: [],
    });
    setItems([]);
    setPayments([]);
    setSelectedAction("New");
    setMakingWastagePercentage("");
    setMakingWastageValue("");
    setIsRoundOffEnabled(false);
    setIsRateManuallyEdited(false);
    setIsAdjustmentApplied(false);
    setStoneValue("");
    setEditingIndex(null);
    setRefundPayType("");
    if (!isManagerLocked) {
      setSelectedManager("");
      setStaffList([]);
    }
    if (!isStaffLocked) {
      setSelectedStaff("");
    }
  };

  const handleEstimate = () => {
    if (!addData.customer_id || !items.length) {
      toast.error(
        "Please select a customer and add at least one item",
        3000,
        "topRight",
      );
      return;
    }
    navigate(`/bill/${addData.sales_no}`, {
      state: {
        salesData: {
          ...addData,
          refund_pay_type:
            parseFloat(addData.refund_amount || 0) > 0 ? refundPayType : "",
          item_list: items,
          payment_history: payments,
        },
        isEstimate: true,
        restore: {
          addData,
          items,
          payments,
          selectedAction,
          makingWastagePercentage,
          makingWastageValue,
        },
      },
    });
  };

  const balanceColor =
    parseFloat(addData.balance) < 0
      ? "red"
      : parseFloat(addData.balance) > 0
        ? "green"
        : "black";

  const filteredCustomers = addData.customer_type
    ? customerData.filter(
        (customer) => customer.customer_type === addData.customer_type,
      )
    : customerData;

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <div className="card p-2 shadow-sm mb-2">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Sales ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sale No"
                    disabled
                    value={generateNumber}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Sales Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={addData.sales_date}
                    onChange={(e) =>
                      setAddData({ ...addData, sales_date: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-9">
            <div className="card h-100 p-2">
              <div className="row g-2">
                <div className="col-md-3">
                  <label className="form-label">
                    Customer Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="customer_type"
                    value={addData.customer_type}
                    onChange={handleCustomerTypeChange}
                  >
                    <option value="">Select Type</option>
                    <option value="Walk-In">Walk-In</option>
                    <option value="Retailer">Retailer</option>
                    <option value="Regular">Regular</option>
                  </select>
                </div>

                {addData.customer_type === "Walk-In" ? (
                  <div className="col-sm-6 col-md-6">
                    <label className="form-label">
                      Walk-In Customer Name{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter customer name"
                      value={addData.customer_name || ""}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          customer_name: e.target.value,
                        })
                      }
                    />
                  </div>
                ) : (
                  <>
                    <div className="col-sm-6 col-md-3">
                      <label className="form-label">
                        Customer <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <select
                          className="form-select"
                          onChange={handleCustomerChange}
                          value={addData.customer_id}
                          disabled={!addData.customer_type}
                        >
                          <option value="">Select Customer</option>
                          {Array.isArray(filteredCustomers) &&
                            filteredCustomers.map((item) => (
                              <option
                                key={item.customer_id}
                                value={item.customer_id}
                              >
                                {item.customer_id} - {item.name}
                              </option>
                            ))}
                        </select>
                        <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-outline-dark btn-sm mx-1"
                            onClick={openCustomerModal}
                            disabled={!addData.customer_type}
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="customer_name"
                        placeholder="Name"
                        value={addData.customer_name || ""}
                        onChange={handleInputChange}
                        disabled
                      />
                    </div>
                    <div className="col-sm-6 col-md-3">
                      <label className="form-label">Mobile Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobile"
                        value={addData.mobile || ""}
                        placeholder="Mobile Number"
                        onChange={handleInputChange}
                        disabled
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="card card-body mt-2">
          <div className="row mb-3">
            <div className="col-lg-4 col-md-4">
              <div className="d-flex mb-2">
                <h6 className="m-2">Item</h6>
                <div>
                  {["New", "Exchange", "Po-Sale", "Old Sales"].map((action) => (
                    <button
                      key={action}
                      className={`btn btn-sm me-2 ${
                        selectedAction === action
                          ? action === "New"
                            ? "active-new btn-primary"
                            : action === "Exchange"
                              ? "active-exchange btn-info"
                              : action === "Po-Sale"
                                ? "active-posale btn-warning"
                                : "active-oldsales btn-success"
                          : "btn-secondary"
                      }`}
                      onClick={() => setSelectedAction(action)}
                    >
                      {action}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4"></div>
            {/* Manager Dropdown */}
            <div className="col-md-2 col-lg-2">
              <label className="form-label">
                Manager <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                value={selectedManager}
                onChange={handleManagerChange}
                disabled={isManagerLocked}
              >
                <option value="">Select Manager</option>
                {userdata
                  .filter(
                    (user) =>
                      user.role === "Manager" || user.role === "manager",
                  )
                  .map((manager) => (
                    <option key={manager.id} value={manager.id}>
                      {manager.name}
                    </option>
                  ))}
              </select>
            </div>
            {/* Staff Dropdown - hidden for Admin */}
            {(() => {
              const role =
                JSON.parse(localStorage.getItem("user") || "{}").role || "";
              const isAdmin = role === "Admin" || role === "admin";
              if (isAdmin) return null;
              return (
                <div className="col-md-2 col-lg-2">
                  <label className="form-label">Staff</label>
                  <select
                    className="form-select"
                    value={selectedStaff}
                    onChange={handleStaffChange}
                    disabled={isStaffLocked}
                  >
                    <option value="">Select Staff</option>
                    {staffList.map((staff) => (
                      <option key={staff.id} value={staff.name}>
                        {staff.name}
                      </option>
                    ))}
                  </select>
                </div>
              );
            })()}
          </div>

          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Category</label>
              <select
                className="form-select"
                value={addData.select_category}
                onChange={(e) => {
                  const selectedCategory = e.target.value;
                  setAddData({
                    ...addData,
                    select_category: selectedCategory,
                    select_type: "",
                  });
                }}
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
                <option value="Gold Coin">Gold Coin</option>
                <option value="Silver Coin">Silver Coin</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Item Name</label>
              <div className="d-flex align-items-center">
                <select
                  className="form-select me-2"
                  value={addData.select_type}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setAddData({ ...addData, select_type: selectedId });

                    // Stock info toast is only relevant for New / Po-Sale.
                    if (
                      selectedId &&
                      selectedAction !== "Exchange" &&
                      selectedAction !== "Old Sales"
                    ) {
                      const selectedProduct = productData.find(
                        (p) => String(p.id) === String(selectedId),
                      );
                      if (selectedProduct) {
                        const stockInfo = getStockStatus(
                          addData.select_category,
                          selectedProduct.item_name_english ||
                            selectedProduct.item_name,
                          selectedId,
                        );
                        if (stockInfo.status === "out-of-stock") {
                          toast.warning(
                            "⚠️ This item is currently out of stock!",
                            3000,
                            "topRight",
                          );
                        } else if (stockInfo.status === "low-stock") {
                          toast.warning(
                            `⚠️ Only ${stockInfo.available.toFixed(3)}g left in stock!`,
                            3000,
                            "topRight",
                          );
                        } else if (stockInfo.itemFound) {
                          toast.success(
                            `✅ ${stockInfo.available.toFixed(3)}g available in stock`,
                            2000,
                            "topRight",
                          );
                        }
                      }
                    }
                  }}
                  disabled={!addData.select_category}
                >
                  <option value="">Select Item</option>
                  {productData
                    .filter(
                      (p) =>
                        !addData.select_category ||
                        p.category === addData.select_category,
                    )
                    .map((product) => {
                      const stockInfo = getStockStatus(
                        addData.select_category,
                        product.item_name_english || product.item_name,
                        product.id,
                      );
                      const stockLabel =
                        stockInfo.available !== undefined && stockInfo.itemFound
                          ? ` (Stock: ${stockInfo.available.toFixed(3)}g)`
                          : "";
                      const stockEmoji =
                        stockInfo.status === "out-of-stock"
                          ? " ❌"
                          : stockInfo.status === "low-stock"
                            ? " ⚠️"
                            : "";
                      return (
                        <option key={product.id} value={product.id}>
                          {product.item_name_english || product.item_name}
                          {product.item_name_tamil
                            ? ` / ${product.item_name_tamil}`
                            : ""}
                          {stockLabel}
                          {stockEmoji}
                        </option>
                      );
                    })}
                </select>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={openProductModal}
                  title="Add New Product"
                  disabled={!addData.select_category}
                >
                  <i className="bi bi-plus"></i>
                </button>
              </div>
              {!addData.select_category && (
                <small className="text-muted text-danger">
                  Please select category first
                </small>
              )}
            </div>
            <div className="col-md-2">
              <label className="form-label">Quantity</label>
              <input
                type="text"
                inputMode="numeric"
                className="form-control"
                placeholder="Quantity"
                value={addData.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setAddData({ ...addData, quantity: value });
                  }
                }}
              />
            </div>
            {(selectedAction === "New" ||
              selectedAction === "Po-Sale" ||
              selectedAction === "Old Sales") && (
              <>
                <div className="col-md-2">
                  <label className="form-label">Weight (g)</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Weight"
                    value={addData.weight}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d{0,3}$/.test(value)) {
                        setAddData({ ...addData, weight: value });
                      }
                    }}
                  />
                </div>
                <div className="col-md-1">
                  <label className="form-label">Rate ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Rate"
                    value={addData.rate}
                    readOnly={
                      selectedAction !== "Exchange" &&
                      selectedAction !== "Old Sales"
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setAddData({ ...addData, rate: value });
                        setIsRateManuallyEdited(true);
                      }
                    }}
                  />
                </div>
              </>
            )}
            {(selectedAction === "New" || selectedAction === "Po-Sale") && (
              <>
                <div className="col-md-2">
                  <label className="form-label fw-bold">Stone value ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="0.00"
                    value={stoneValue}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d*$/.test(val) || val === "") {
                        setStoneValue(val);
                      }
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Making Charge ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Making Charges"
                    value={addData.making_charges}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setAddData({ ...addData, making_charges: value });
                      }
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Wastage (g)</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Wastage %"
                    value={makingWastagePercentage}
                    onChange={handleMakingWastagePercentageChange}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Wastage Value ₹</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control"
                    placeholder="Wastage Value"
                    value={makingWastageValue}
                    onChange={handleMakingWastageValueChange}
                  />
                </div>
              </>
            )}
            {/* EXCHANGE MODE */}
            {selectedAction === "Exchange" && (
              <>
                <div className="col-md-3">
                  <label className="form-label">Total Weight (g)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. 10.000"
                    value={addData.weight || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d{0,3}$/.test(val) || val === "") {
                        setAddData({ ...addData, weight: val });
                      }
                    }}
                  />
                </div>
                {renderAdjustmentInput()}
                <div className="col-md-2">
                  <label className="form-label">Rate ₹/g</label>
                  <input
                    type="text"
                    className="form-control"
                    value={addData.rate || ""}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*\.?\d*$/.test(val) || val === "") {
                        setAddData({ ...addData, rate: val });
                        setIsRateManuallyEdited(true);
                      }
                    }}
                  />
                </div>
              </>
            )}
            <div className="col-md-2">
              <label className="form-label">Amount ₹</label>
              <input
                type="text"
                className="form-control bg-light"
                value={addData.amount}
                readOnly
              />
            </div>
            <div className="col-md-1">
              <button
                className={`btn btn-sm mt-4 ${
                  editingIndex === null ? "btn-success" : "btn-info"
                }`}
                onClick={handleAddItem}
              >
                <i
                  className={`bi ${
                    editingIndex === null ? "bi-plus" : "bi-check"
                  }`}
                ></i>
              </button>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-8">
              <div className="card card-body">
                <h6>Item List</h6>
                <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                  <table className="table table-layout-fixed w-100">
                    <thead className="bg-light">
                      <tr>
                        <th>S.No</th>
                        <th>Category</th>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Wgt (g)</th>
                        <th>Stone Value ₹</th>
                        <th>MC ₹</th>
                        <th>Rate ₹</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.length > 0 ? (
                        items.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.category}</td>
                            <td>
                              {item.item || item.type_id}
                              {(() => {
                                const product = productData.find(
                                  (p) => String(p.id) === String(item.type_id),
                                );
                                return product?.item_name_tamil ? (
                                  <small className="text-muted d-block tamil-text">
                                    {product.item_name_tamil}
                                  </small>
                                ) : null;
                              })()}
                            </td>
                            <td>{item.quantity}</td>
                            <td>
                              {item.weight} (g)
                              {item.adjustment &&
                              parseFloat(item.adjustment) !== 0 ? (
                                <small className="text-muted d-block">
                                  Adj: {parseFloat(item.adjustment) > 0 ? "+" : ""}
                                  {parseFloat(item.adjustment).toFixed(3)} g
                                </small>
                              ) : null}
                            </td>
                            <td>{item.stone_value || "-"}</td>
                            <td>{item.making_charges || "-"}</td>
                            <td>{item.rate}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary me-1"
                                onClick={() => handleEditItem(index)}
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDeleteItem(index)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No items added
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="row">
                    <div className="col-lg-8"></div>
                    <div className="col-lg-4">
                      <div className="d-flex">
                        <h6 className="mt-2">Total: </h6>
                        <input
                          className="form-control mx-2"
                          value={addData.total}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ==================================================================
                  Payment History — scoped to THIS sale only (sales_no: {generateNumber}).
                  Sourced from the local `payments` state, which only ever contains
                  payments added for the current sale being created (see
                  handleAddPayment / handleDeletePayment above). This intentionally
                  no longer fetches/shows the customer's other past sales.
                 ================================================================== */}
              {addData.customer_id && (
                <div className="card card-body mt-2">
                  <h6>
                    Payment History — {addData.customer_name} (Sales No:{" "}
                    {generateNumber || addData.sales_no || "New"})
                  </h6>
                  <div className="p-2" style={{ backgroundColor: "#E8F0FA" }}>
                    <div className="table-container">
                      <table className="table table-layout-fixed w-100">
                        <thead className="bg-light">
                          <tr>
                            <th>S.No</th>
                            <th>Date</th>
                            <th>Payment Type</th>
                            <th>Amount ₹</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payments.length > 0 ? (
                            payments.map((payment, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{formatDateToDDMMYYYY(payment.date)}</td>
                                <td>{payment.payment_type}</td>
                                <td>
                                  ₹{parseFloat(payment.amount || 0).toFixed(2)}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No payments recorded for this sale yet
                              </td>
                            </tr>
                          )}
                          {payments.length > 0 && (
                            <tr className="table-warning fw-bold">
                              <td colSpan="3" className="text-end">
                                Total Paid
                              </td>
                              <td>
                                ₹{parseFloat(addData.paid || 0).toFixed(2)}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4 mb-5">
              <div className="card p-3">
                <div className="row mb-1">
                  <div className="col-md-4">
                    <label className="form-label">Discount (%)</label>
                    <input
                      type="tel"
                      className="form-control form-control-sm"
                      placeholder="%"
                      value={addData.discount}
                      onChange={(e) => {
                        const pct = e.target.value.replace(/[^0-9.]/g, "");
                        if (/^\d*\.?\d{0,2}$/.test(pct) || pct === "") {
                          const total = parseFloat(addData.total) || 0;
                          const maxPct = getMaxDiscountPercent();

                          if (pct && parseFloat(pct) > maxPct) {
                            toast.error(
                              `⚠️ Maximum discount allowed is ${maxPct.toFixed(2)}%`,
                              3000,
                              "topRight",
                            );
                          }

                          const discAmt = pct
                            ? ((total * parseFloat(pct)) / 100).toFixed(2)
                            : "0.00";
                          setDiscountAmountInput(discAmt);
                          setAddData({ ...addData, discount: pct });
                        }
                      }}
                    />
                    {showMaxDiscount && (
                      <div
                        className="small text-muted"
                        style={{ marginTop: "-20px" }}
                      >
                        Max dis: {getMaxDiscountPercent().toFixed(2)} %
                      </div>
                    )}
                    <button
                      type="button"
                      className="btn btn-link btn-sm"
                      style={{ marginTop: "-20px" }}
                      onClick={() => setShowMaxDiscount(!showMaxDiscount)}
                    >
                      {showMaxDiscount ? <FaRegEyeSlash /> : <FaRegEye />}
                    </button>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Amount ₹</label>
                    <input
                      type="tel"
                      className="form-control form-control-sm"
                      placeholder="₹"
                      value={discountAmountInput}
                      onChange={(e) => {
                        const amt = e.target.value.replace(/[^0-9.]/g, "");
                        if (/^\d*\.?\d{0,2}$/.test(amt) || amt === "") {
                          setDiscountAmountInput(amt);
                          const total = parseFloat(addData.total) || 0;
                          const pct =
                            amt && total > 0
                              ? ((parseFloat(amt) / total) * 100).toFixed(2)
                              : "";

                          const maxPct = getMaxDiscountPercent();
                          if (pct && parseFloat(pct) > maxPct) {
                            toast.error(
                              `⚠️ Maximum discount allowed is ${maxPct.toFixed(2)}%`,
                              3000,
                              "topRight",
                            );
                          }

                          setAddData({ ...addData, discount: pct });
                        }
                      }}
                    />
                    {showMaxDiscount && (
                      <div
                        className="small text-muted"
                        style={{ marginTop: "-20px" }}
                      >
                        Max amt: ₹
                        {(
                          ((parseFloat(addData.total) || 0) *
                            getMaxDiscountPercent()) /
                          100
                        ).toFixed(2)}
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Disc. Value</label>
                    <input
                      type="tel"
                      className="form-control form-control-sm"
                      value={addData.discount_value}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-1">
                  <div className="col-md-6">
                    <label className="form-label">Sub Total</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control form-control-sm"
                      value={addData.sub_total}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-1">
                  <div className="col-md-4">
                    <label className="form-label">GST (%)</label>
                    <div className="d-flex align-items-center gap-1">
                      <input
                        type="checkbox"
                        id="gstToggle"
                        checked={isGstIncluded}
                        onChange={(e) => {
                          setIsGstIncluded(e.target.checked);
                          if (!e.target.checked) {
                            setAddData((prev) => ({
                              ...prev,
                              tax: "",
                              tax_percentage: "0.00",
                            }));
                          }
                        }}
                        className="form-check-input mt-0"
                        title="Check to include GST"
                      />
                      <label
                        htmlFor="gstToggle"
                        className="form-label mb-0 small"
                      >
                        {isGstIncluded ? "Incl." : "Excl."}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control form-control-sm mt-1"
                      value={isGstIncluded ? addData.tax : ""}
                      placeholder="%"
                      disabled={!isGstIncluded}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          tax: e.target.value.replace(/[^0-9.]/g, ""),
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="tel"
                      className="form-control form-control-sm mt-1"
                      value={isGstIncluded ? addData.tax_percentage : "0.00"}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">Round Off</label>
                  </div>
                  <div className="col-md-2">
                    <input
                      type="checkbox"
                      checked={isRoundOffEnabled}
                      onChange={(e) => setIsRoundOffEnabled(e.target.checked)}
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={addData.round_off}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Net Total</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={addData.net_total}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Exchange Old</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={addData.exchange_old_value}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-2 d-flex justify-content-center">
                  <button
                    className="btn btn-success btn-sm w-50"
                    onClick={() => setInfoModal(true)}
                  >
                    Add Payment +
                  </button>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Paid</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={addData.paid}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Balance</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="tel"
                      className="form-control"
                      value={Math.abs(parseFloat(addData.balance)).toFixed(2)}
                      readOnly
                      style={{ color: balanceColor }}
                    />
                  </div>
                </div>
                {parseFloat(addData.refund_amount || 0) > 0 && (
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label text-danger">
                        Paid to Customer
                      </label>
                    </div>
                    <div className="col-md-3">
                      <select
                        className="form-select"
                        value={refundPayType}
                        onChange={(e) => setRefundPayType(e.target.value)}
                      >
                        <option value="">Select Paytype</option>
                        <option value="Cash">Cash</option>
                        <option value="Gpay">Gpay</option>
                        <option value="Phonepe">Phonepe</option>
                        <option value="Paytm">Paytm</option>
                        <option value="Credit">Credit</option>
                        <option value="Debit">Debit</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <input
                        type="tel"
                        className="form-control text-danger"
                        value={parseFloat(addData.refund_amount).toFixed(2)}
                        readOnly
                      />
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Notes</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      value={addData.notes}
                      onChange={(e) =>
                        setAddData({ ...addData, notes: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => navigate("/sales")}
                  >
                    <i className="bi bi-arrow-left"></i> Back
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={handleClear}
                  >
                    <i className="bi bi-x-circle"></i> Clear
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleEstimate}
                  >
                    <i className="bi bi-printer"></i> Estimate
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleSave}
                    disabled={loading}
                  >
                    <i className="bi bi-save"></i> Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Payment Modal */}
        <div
          className={`modal fade ${infoModal ? "show" : ""}`}
          style={{ display: infoModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addPaymentModalLabel"
          aria-hidden={!infoModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6
                  className="modal-title text-primary"
                  id="addPaymentModalLabel"
                >
                  Add Payment
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={() => setInfoModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <p>
                      Balance:{" "}
                      <span className="mx-3 text-success">
                        {Math.abs(parseFloat(addData.balance)).toFixed(2)}
                      </span>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      Paid:{" "}
                      <span className="mx-3 text-primary">{addData.paid}</span>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <select
                      className="form-select"
                      value={paymentType}
                      onChange={(e) => setPaymentType(e.target.value)}
                    >
                      <option value="">Select Paytype</option>
                      <option value="Cash">Cash</option>
                      <option value="Gpay">Gpay</option>
                      <option value="Phonepe">Phonepe</option>
                      <option value="Paytm">Paytm</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <input
                      type="tel"
                      className="form-control"
                      value={paymentAmount}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                      placeholder="Enter Amount"
                    />
                  </div>
                  <div className="col-lg-2">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleAddPayment}
                    >
                      Add +
                    </button>
                  </div>
                </div>
                <div
                  className="card mt-3"
                  style={{ borderRadius: "5px", backgroundColor: "#E8F0FA" }}
                >
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-border">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Pay Type</th>
                            <th>Paid Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payments.length > 0 ? (
                            payments.map((payment, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{payment.payment_type}</td>
                                <td>{payment.amount}</td>
                                <td>
                                  <button
                                    className="btn btn-light btn-sm me-2"
                                    onClick={() => handleEditPayment(index)}
                                  >
                                    <i className="bi bi-pencil text-info"></i>
                                  </button>
                                  <button
                                    className="btn btn-light btn-sm me-2"
                                    onClick={() => handleDeletePayment(index)}
                                  >
                                    <i className="bi bi-trash text-danger"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No payments added
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="text-end mt-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => setInfoModal(false)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Customer Modal */}
        <div
          className={`modal fade ${showCustomerModal ? "show" : ""}`}
          style={{ display: showCustomerModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addCustomerModalLabel"
          aria-hidden={!showCustomerModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6
                  className="modal-title text-primary"
                  id="addCustomerModalLabel"
                >
                  Add Customer
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeCustomerModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleCustomerSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="customerType" className="form-label">
                          Customer Type <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          id="customerType"
                          value={addData.customer_type}
                          onChange={handleCustomerTypeChange}
                          required
                        >
                          <option value="">Select Customer Type</option>
                          <option value="Walk-In">Walk-In</option>
                          <option value="Regular">Regular</option>
                          <option value="Retailer">Retailer</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="customerId" className="form-label">
                          Customer ID <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="customerId"
                          placeholder="Customer ID will be generated automatically"
                          value={generateCustomerNumber}
                          disabled
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter Name"
                          value={addData.customer_name}
                          onChange={(e) =>
                            setAddData({
                              ...addData,
                              customer_name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="mobile" className="form-label">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          id="mobile"
                          placeholder="Enter Mobile"
                          value={addData.mobile}
                          onChange={(e) =>
                            setAddData({ ...addData, mobile: e.target.value })
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="Enter Address"
                      value={addData.address}
                      onChange={(e) =>
                        setAddData({ ...addData, address: e.target.value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="customerStatus" className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      id="status"
                      value={addData.status}
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Add Product Modal */}
        <div
          className={`modal fade ${showProductModal ? "show" : ""}`}
          style={{
            display: showProductModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="addProductModalLabel"
          aria-hidden={!showProductModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6
                  className="modal-title text-primary"
                  id="addProductModalLabel"
                >
                  Add Product
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeProductModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleProductSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="item_code" className="form-label">
                          Item Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="item_code"
                          value={productAddData.item_code}
                          disabled
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="product_category"
                          className="form-label"
                        >
                          Category <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-select ${
                            productFormErrors.category ? "is-invalid" : ""
                          }`}
                          id="product_category"
                          value={productAddData.category}
                          onChange={(e) =>
                            setProductAddData({
                              ...productAddData,
                              category: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Category</option>
                          <option value="Gold">Gold</option>
                          <option value="Silver">Silver</option>
                          <option value="Gold Coin">Gold Coin</option>
                          <option value="Silver Coin">Silver Coin</option>
                        </select>
                        {productFormErrors.category && (
                          <div className="invalid-feedback">
                            {productFormErrors.category}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label
                          htmlFor="item_name_english"
                          className="form-label"
                        >
                          Item Name <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className={`form-control ${
                              productFormErrors.item_name ? "is-invalid" : ""
                            }`}
                            id="item_name_english"
                            placeholder="Enter item name in English (Tamil will auto-translate)"
                            value={productAddData.item_name_english}
                            onChange={(e) =>
                              setProductAddData({
                                ...productAddData,
                                item_name_english: e.target.value,
                                item_name: e.target.value,
                                item_name_tamil: "",
                              })
                            }
                            onBlur={async (e) => {
                              const val = e.target.value.trim();
                              if (val && !productAddData.item_name_tamil) {
                                const tamil = await translateToTamil(val);
                                if (tamil) {
                                  setProductAddData((prev) => ({
                                    ...prev,
                                    item_name_tamil: tamil,
                                  }));
                                  toast.info(
                                    `Tamil translation: ${tamil}`,
                                    2000,
                                    "topRight",
                                  );
                                }
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Translate to Tamil"
                            style={{ height: "35px" }}
                            disabled={
                              isTranslating || !productAddData.item_name_english
                            }
                            onClick={async () => {
                              const tamil = await translateToTamil(
                                productAddData.item_name_english,
                              );
                              if (tamil) {
                                setProductAddData((prev) => ({
                                  ...prev,
                                  item_name_tamil: tamil,
                                }));
                                toast.success(
                                  "Translated successfully!",
                                  1500,
                                  "topRight",
                                );
                              } else {
                                toast.error(
                                  "Translation failed. Please try again.",
                                  2000,
                                  "topRight",
                                );
                              }
                            }}
                          >
                            {isTranslating ? (
                              <span className="spinner-border spinner-border-sm" />
                            ) : (
                              "🌐 Translate"
                            )}
                          </button>
                        </div>
                        {productAddData.item_name_tamil && (
                          <small className="text-muted mt-1 d-block">
                            <strong>Tamil:</strong>{" "}
                            {productAddData.item_name_tamil}
                            <button
                              type="button"
                              className="btn btn-link btn-sm p-0 ms-2 text-muted"
                              onClick={() =>
                                setProductAddData((prev) => ({
                                  ...prev,
                                  item_name_tamil: "",
                                }))
                              }
                            >
                              ✕ clear
                            </button>
                          </small>
                        )}
                        {productFormErrors.item_name && (
                          <div className="invalid-feedback">
                            {productFormErrors.item_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="pure_percent" className="form-label">
                          Purity (%) <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          className={`form-control ${
                            productFormErrors.pure_percent ? "is-invalid" : ""
                          }`}
                          id="pure_percent"
                          placeholder="e.g. 99.9"
                          value={productAddData.pure_percent}
                          onChange={(e) =>
                            setProductAddData({
                              ...productAddData,
                              pure_percent: e.target.value,
                            })
                          }
                        />
                        {productFormErrors.pure_percent && (
                          <div className="invalid-feedback">
                            {productFormErrors.pure_percent}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="product_status" className="form-label">
                          Status <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-select ${
                            productFormErrors.status ? "is-invalid" : ""
                          }`}
                          id="product_status"
                          value={productAddData.status}
                          onChange={(e) =>
                            setProductAddData({
                              ...productAddData,
                              status: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                        {productFormErrors.status && (
                          <div className="invalid-feedback">
                            {productFormErrors.status}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3">
                      <label htmlFor="product_image" className="form-label">
                        Image Upload
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="product_image"
                        onChange={(e) =>
                          setProductAddData({
                            ...productAddData,
                            image: e.target.files[0],
                          })
                        }
                        accept="image/*"
                      />
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-4"
                      disabled={loading}
                    >
                      {loading ? "Adding..." : "Add Product"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {(infoModal || showCustomerModal || showProductModal) && (
          <div className="modal-backdrop fade show"></div>
        )}
      </div>
    </>
  );
}

export default AddSales;